export enum PrivacyTypeEnum {
    All = 'all',
    Public = 'public',
    Private = 'private',
    Follower = 'follower',
    Anonymous = 'anonymous',
    Group = 'group',
}

export const PRIVACY_TYPE_LABEL: Record<PrivacyTypeEnum, string> = {
    [PrivacyTypeEnum.All]: 'All',
    [PrivacyTypeEnum.Public]: 'Public',
    [PrivacyTypeEnum.Private]: 'Private',
    [PrivacyTypeEnum.Follower]: 'Friends',
    [PrivacyTypeEnum.Anonymous]: 'Anonymous',
    [PrivacyTypeEnum.Group]: 'Group',
};

export function getPrivacyTypeLabel(type: PrivacyTypeEnum): string {
    return PRIVACY_TYPE_LABEL[type] || type;
}
